import dayjs from "dayjs";

export const formatMileage = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "";
  }

  return `${Number(value).toLocaleString()} mi`;
};

export const formatDateDisplay = (value, format = "MMM DD, YYYY") => {
  if (!value) return "";
  const date = dayjs(value);
  if (!date.isValid()) return value;
  return date.format(format);
};

export const APPOINTMENT_STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  { label: "Closed", value: "CLOSED" },
];

export const LAST_UPDATE_PRESETS = [
  { label: "Today", value: "today" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "This month", value: "this_month" },
  { label: "This year", value: "this_year" },
];

export const getDateRangeForPreset = (preset) => {
  const today = dayjs().startOf("day");

  switch (preset) {
    case "today":
      return {
        from: today.format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "last_7_days":
      return {
        from: today.subtract(7, "day").format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "last_30_days":
      return {
        from: today.subtract(30, "day").format("YYYY-MM-DD"),
        to: today.endOf("day").format("YYYY-MM-DD"),
      };
    case "this_month":
      return {
        from: today.startOf("month").format("YYYY-MM-DD"),
        to: today.endOf("month").format("YYYY-MM-DD"),
      };
    case "this_year":
      return {
        from: today.startOf("year").format("YYYY-MM-DD"),
        to: today.endOf("year").format("YYYY-MM-DD"),
      };
    default:
      return { from: null, to: null };
  }
};

export const getStatusColor = (status) => {
  if (!status) return "neutral";
  const normalized = status.toUpperCase();
  if (normalized === "ACTIVE") return "informative";
  if (normalized === "CLOSED") return "neutral";
  return "neutral";
};

